import { render, staticRenderFns } from "./FavoritesTable.vue?vue&type=template&id=aa7e05d4&"
import script from "./FavoritesTable.vue?vue&type=script&lang=js&"
export * from "./FavoritesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports